<script lang="ts" setup>
import type { ConcreteComponent } from 'vue'
import { storeToRefs } from 'pinia'
import { useMedia } from '~/store/media'

const { media } = storeToRefs(useMedia())

const MediaCard = markRaw(resolveComponent('LazyCardMedia') as ConcreteComponent)
</script>

<template lang="pug">
section.media__alpha
  h1 {{ $t('media.alpha.title') }}
  .media__alpha__slider
    UISlider(
      :component="MediaCard",
      :slides="media",
      :fade="true"
      :auto-play="true"
      :parallax="true"
      :perspective="true"
    )
</template>

<style lang="sass" scoped>
section.media__alpha
  @apply w-full h-full flex-center flex-col gap-8
  h1
    @apply text-3xl lg:text-5xl leading-4 text-center font-bold text-animated
  .media__alpha__slider
    @apply w-full
</style>
